const carouselItems = [
  {
    title: '暑期档必看：2026科幻大片盘点',
    desc: '从星际征途到AI觉醒，六部年度科幻神作高清在线观看，蓝光画质带来前所未有的视觉冲击。',
    tag: '专题策划',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20cinematic%20scene%20with%20cosmic%20nebula%20and%20spaceship%20silhouette%2C%20dramatic%20lighting%20with%20deep%20blue%20and%20golden%20accents%2C%20epic%20movie%20poster%20style%2C%20atmospheric%20and%20grand%2C%20professional%20film%20photography%20aesthetic&width=800&height=500&seq=carousel-01-sci-fi&orientation=landscape',
  },
  {
    title: '经典港片蓝光重制：回到黄金年代',
    desc: '周星驰、成龙、周润发、张国荣，那些年我们追过的港片以4K蓝光画质焕新归来。',
    tag: '经典重制',
    img: 'https://readdy.ai/api/search-image?query=Classic%20Hong%20Kong%20cinema%20atmosphere%20with%20warm%20vintage%20golden%20lighting%2C%20retro%20film%20poster%20collage%20style%2C%20nostalgic%201990s%20movie%20aesthetic%2C%20rich%20amber%20and%20crimson%20tones%2C%20cinematic%20composition&width=800&height=500&seq=carousel-02-hk-film&orientation=landscape',
  },
  {
    title: '豆瓣8.5+高分神作合集',
    desc: '全球口碑炸裂的高分影视作品一网打尽，悬疑烧脑、温情治愈、史诗巨制，每一部都值得细品。',
    tag: '高分精选',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20film%20awards%20ceremony%20atmosphere%20with%20golden%20trophies%20and%20red%20carpet%2C%20prestigious%20cinema%20theme%2C%20warm%20theatrical%20lighting%20with%20soft%20golden%20glow%2C%20sophisticated%20and%20refined%20movie%20aesthetic&width=800&height=500&seq=carousel-03-high-rated&orientation=landscape',
  },
  {
    title: '追剧指南：2026年最火国产剧',
    desc: '高分国产剧免费全集在线观看，古装权谋、都市情感、悬疑推理，高清电视剧持续更新中。',
    tag: '追剧推荐',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20cinematic%20scene%20with%20ancient%20palace%20and%20flowing%20silk%20fabrics%2C%20dramatic%20lighting%20with%20warm%20golden%20and%20vermilion%20tones%2C%20elegant%20costume%20film%20photography%2C%20atmospheric%20mist&width=800&height=500&seq=carousel-04-drama&orientation=landscape',
  },
  {
    title: '纪录片爱好者不可错过的自然大片',
    desc: 'BBC、国家地理顶级制作，从深海到极地、从丛林到沙漠，蓝光画质呈现地球的壮丽奇观。',
    tag: '纪录片精选',
    img: 'https://readdy.ai/api/search-image?query=Breathtaking%20aerial%20nature%20documentary%20scene%20with%20vast%20mountain%20range%20and%20golden%20sunrise%20light%2C%20epic%20landscape%20cinematography%2C%20rich%20warm%20earthy%20tones%2C%20National%20Geographic%20style%2C%20dramatic%20clouds&width=800&height=500&seq=carousel-05-nature&orientation=landscape',
  },
  {
    title: '周末治愈系：温暖人心的日系电影',
    desc: '精选日本高分治愈电影，从是枝裕和到宫崎骏，每一帧画面都温暖人心，超清画质感动加倍。',
    tag: '治愈推荐',
    img: 'https://readdy.ai/api/search-image?query=Warm%20Japanese%20countryside%20cinematic%20scene%20with%20soft%20sunlight%20through%20cherry%20blossoms%2C%20gentle%20pastel%20color%20palette%2C%20peaceful%20slice-of-life%20film%20aesthetic%2C%20nostalgic%20and%20heartwarming%20atmosphere&width=800&height=500&seq=carousel-06-japan&orientation=landscape',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="py-12 md:py-16 bg-background-100">
      <div className="section-container">
        <h2 className="font-display text-2xl md:text-3xl text-foreground-950 text-center mb-2">精选专题</h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">精心策划的高清影视专题合集</p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {carouselItems.map((item, i) => (
            <a
              key={i}
              href="#carousel"
              onClick={(e) => e.preventDefault()}
              className="bg-background-50 rounded-lg overflow-hidden cursor-pointer group"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-flex items-center px-2.5 py-1 rounded-full text-[10px] font-medium bg-background-50/90 text-foreground-800 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-background-900/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1.5 whitespace-nowrap">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}